module.exports = __webpack_public_path__ + "img/e6e22bb2bb3ca6cb6d7ea4777b3e0bef.png";